<template>
	<div class="box">
        <LoadingSpinner v-if="loading" />
        <div v-else id="marelist">
        	<h2>{{ $t('horse.tiers_proprietaires') }}</h2>
        	
        	<table class="table table-hover table-sm mb-0">
        		<thead>
        			<tr>
        				<th>{{ $t('tiers.rs') }}</th>
        				<th>{{ $t('tiers.address1') }}</th>
        				<th>{{ $t('tiers.email') }}</th>
        				<th>{{ $t('tiers.phone') }}</th>
        				<th>{{ $t('tiers.poucentage_pensions') }}</th>
        				<th>{{ $t('tiers.poucentage_frais') }}</th>
        				<th>{{ $t('tiers.poucentage_contract') }}</th>
        				<th>{{ $t('tiers.poucentage_propriete') }}</th>
        			</tr>
        		</thead>
        		<tbody>
        			<template  v-for="(tier, index) in tiers">
	        			<tr :key="index" style="border-top: 4px solid #e2e6ea">
	        				<td>{{ tier.tiers_rs }}</td>
	        				<td>
		        				{{ tier.tiers_address1 }}<br>
		        				{{ tier.tiers_postalcode }} {{ tier.tiers_town }}<br>
		        				{{ tier.tiers_country }}
		        			</td>
	        				<td>{{ tier.tiers_mail }}</td>
	        				<td>{{ tier.tiers_phone }}</td>
	        				<td>{{ tier.tiershorsepart_pension }} %</td>
	        				<td>{{ tier.tiershorsepart_frais }} %</td>
	        				<td>{{ tier.tiershorsepart_contract }} %</td>
	        				<td>{{ tier.tiershorsepart_propriete }} %</td>
	        			</tr>
	        			<template v-if="tier.contacts.length > 0">
		        			<tr :key="'contact_'+index" style="border-top: 2px solid #e2e6ea">
		        				<td colspan="8">{{ $t('tiers.contact_tiers') }} : </td>
		        			</tr>
		        			<tr v-for="(contact, index_c) in tier.contacts" :key="'contact_'+index+'_'+index_c">
		        				<td></td>
		        				<td>
			        				{{ contact.contact_civility }} {{ contact.contact_firstname }} {{ contact.contact_lastname }}<br>
			        				{{ contact.contact_address1 }}<br>
			        				{{ contact.contact_postalcode }} {{ contact.contact_town }}<br>
			        				{{ contact.contact_country }}<br>
			        			</td>
		        				<td>{{ contact.contact_mail }}</td>
		        				<td>{{ contact.contact_phone }}</td>
		        				<td></td>
		        				<td></td>
		        				<td></td>
		        				<td></td>
		        			</tr>
		        		</template>
	        		</template>
        		</tbody>
        	</table>

        	<h2>{{ $t('horse.tiers_secondaires') }}</h2>
        	<table class="table table-hover table-sm mb-0">
        		<thead>
        			<tr>
        				<th>{{ $t('tiers.rs') }}</th>
        				<th>{{ $t('tiers.address1') }}</th>
        				<th>{{ $t('tiers.email') }}</th>
        				<th>{{ $t('tiers.phone') }}</th>
        				<th>{{ $t('tiers.fonction.title') }}</th>
        			</tr>
        		</thead>
        		<tbody>
        			<tr v-for="(tier, index) in tiers_secondaires" :key="index" style="border-top: 4px solid #e2e6ea">
        				<td>{{ tier.tiers_rs }}</td>
        				<td>
	        				{{ tier.tiers_address1 }}<br>
	        				{{ tier.tiers_postalcode }} {{ tier.tiers_town }}<br>
	        				{{ tier.tiers_country }}
	        			</td>
        				<td>{{ tier.tiers_mail }}</td>
        				<td>{{ tier.tiers_phone }}</td>
        				<td>{{ $t('tiers.'+tier.fonction) }}</td>
        			</tr>
	        	</tbody>
	        </table>

        	<h2>{{ $t('horse.contacts') }}</h2>
        	<table class="table table-hover table-sm mb-0">
        		<thead>
        			<tr>
        				<th>{{ $t('tiers.rs') }}</th>
        				<th>{{ $t('tiers.address1') }}</th>
        				<th>{{ $t('tiers.email') }}</th>
        				<th>{{ $t('tiers.phone') }}</th>
        			</tr>
        		</thead>
        		<tbody>
        			<tr v-for="(contact, index) in contacts" :key="index" style="border-top: 4px solid #e2e6ea">
        				<td>{{ contact.contact_civility }} {{ contact.contact_firstname }} {{ contact.contact_lastname }}</td>
        				<td>
	        				{{ contact.contact_address1 }}<br>
	        				{{ contact.contact_postalcode }} {{ contact.contact_town }}<br>
	        				{{ contact.contact_country }}
	        			</td>
        				<td>{{ contact.contact_mail }}</td>
        				<td>{{ contact.contact_phone }}</td>
        			</tr>
	        	</tbody>
	        </table>
        </div>
	</div>
</template>

<script type="text/javascript">
	import Tiers from '@/mixins/Tiers.js'

	export default {
		name: 'TiersContact',
		mixins: [Tiers],
		props: ['horse_id'],
		data () {
			return {
				loading: false,
				tiers: [],
				tiers_secondaires: [],
				contacts: []
			}
		},

		mounted() {
			this.init_component()
		},

		methods: {
			async init_component() {
				this.loading = true
				await this.getHorseTiersContacts(this.horse_id).then(data => {
					this.tiers = data.tiers_horse
					this.tiers_secondaires = data.tiers_secondaires
					this.contacts = data.contacts
					this.loading = false
				})
			},
		},

		components: {
            LoadingSpinner : () => import('GroomyRoot/components/Logos/LoadingSpinner_35'),
		}
	}

</script>